// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__2Uaa3","drawer":"Accordion_drawer__2XZ2J","accordionChevron":"Accordion_accordionChevron__mIIsn"};